import { privacyByLocale, seoByLocale } from "../content";
import { LegalPage } from "../components/LegalPage";
import { SiteLayout } from "../components/SiteLayout";
import type { Locale } from "../content/types";
import { usePageSeo } from "../lib/seo";

type PrivacyPageProps = {
  locale: Locale;
};

export function PrivacyPage({ locale }: PrivacyPageProps) {
  usePageSeo({ locale, routeKind: "privacy", seo: seoByLocale[locale].privacy });

  return (
    <SiteLayout locale={locale} page="privacy">
      <div className="legal-page">
        <LegalPage content={privacyByLocale[locale]} />
      </div>
    </SiteLayout>
  );
}
